import { getMyPermissions } from "./functions/GetMyPermissions";

export default function PermissionCheck({ permission, children, reason }) {
  const perm = JSON.parse(localStorage.getItem("user"));
  console.log("User Permissions", perm?.isHeadOfUnit);
  return getMyPermissions().includes(permission) || perm?.isHeadOfUnit ? (
    children
  ) : (
    <>{reason}</>
  );
}
